import { WelcomeScreen } from '@/features/setup/screens';
export default WelcomeScreen;
